import { motion } from 'motion/react';

import styles from './Question.module.css';

export const Question = ({ question }) => {
  return (
    <div className={styles.questionBlock}>
      <motion.div
        className={styles.question}
        initial={{ x: '100%' }}
        animate={{ x: '0%' }}
        transition={{ duration: 1 }}
        exit={{ opacity: 0 }}
      >
        {question}
      </motion.div>

      <motion.div
        initial={{ scaleX: 0, originX: 0 }}
        animate={{ scaleX: 1 }}
        transition={{ duration: 1 }}
        exit={{ opacity: 0 }}
        className={styles.questionBg}
      />
    </div>
  );
};
